import React, { PureComponent } from 'react';
import { IReducerState } from '../../../states/renditionStates';
import { connect } from 'react-redux';
import {switchPage} from "../../../utils/api/pageControl";
import {localI18nData} from "../../../utils/general/resourceBundleServices";
import { enterKeyPressed } from '../../../utils/general/enterKey';

interface ISupplyChainProps {
    docHeaderSectionJson: any;
    showOldBranding: boolean;
}

export class SupplyChain extends PureComponent<ISupplyChainProps> {
    public render() {
        const supplyChainText = localI18nData(this.props.docHeaderSectionJson.metadata.isJP).data.supplyChain;
        return (
            <React.Fragment>
                <div className="financials">
                    {
                        this.props.showOldBranding ? <span className="icon-supply-chain icon-sprite" role="img" aria-label={supplyChainText}/> : <span className='icon-svg-parent'>
                        <span className="icon-svg icon-supply-chain-svg" role="img" aria-label={supplyChainText} />
                        </span>
                    }
                    <a tabIndex={0} role="link" className="x-rsch-hyperlink"
                       onClick={() => switchPage("supplyChainCompanyListPage")}
                       onKeyPress={(e) => enterKeyPressed(e, switchPage.bind(this, "supplyChainCompanyListPage"))}
                       aria-label={supplyChainText}
                    >{supplyChainText}</a>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state: IReducerState) => {
    return {
        docHeaderSectionJson: state.asyncStateReducer.docHeaderJsonData,
    };
};

export default connect(mapStateToProps)(SupplyChain);
